import { render, staticRenderFns } from "./multistageApproval.vue?vue&type=template&id=555e9c5f&scoped=true&"
import script from "./multistageApproval.vue?vue&type=script&lang=js&"
export * from "./multistageApproval.vue?vue&type=script&lang=js&"
import style0 from "./multistageApproval.vue?vue&type=style&index=0&id=555e9c5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555e9c5f",
  null
  
)

export default component.exports